import { SvgIconClassKey } from '@material-ui/core/SvgIcon';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDSvgIconStyles: Partial<Record<SvgIconClassKey, CSSProperties>> =
  {
    root: {
      fontSize: '2.5rem',
    },
    colorPrimary: {},
    colorSecondary: {},
    colorAction: {},
    colorDisabled: {},
    colorError: {},
    fontSizeInherit: {},
    fontSizeSmall: {},
    fontSizeLarge: {},
  };
